import React, { useState, useEffect } from "react";
import SubmitForm from "../SubmitForm/SubmitForm";
import Navbar from "../../../common/Navbar/Navbar";
import "./externalformheader.css";
import GeneralTooltipsModal from "../../../Modals/FormTooltipsModal/GeneralTooltipsModal";

/**
 * Header for the External Form where the external client 
 * finds the Submit button and the Analyst 
 * can Submit and Merge the Data
 */

export default function ExternalFormHeader({
  formData,
  isExternalMember,
  showCheckboxes,
  setShowCheckboxes,
  checkboxState,
}) {
  const companyName = formData?.CompanyName;
  const status = formData?.Status;
  const [showStatus, setShowStatus] = useState(status);
  const dateTime = formData?.DateTime;
  const snapshotName = formData?.SnapshotName;
  const memberName = formData?.MemberName;

  //Set the Status in the Header section
  useEffect(() => {
    if (status === "In Progress") {
      setShowStatus("Submission Pending");
    } else if (status === "Completed") {
      setShowStatus("Submitted");
    } else if (status === "Merged") {
      setShowStatus("Merged");
    } else {
      setShowStatus(status);
    }
  }, [status]);

  function getStatusClassName(status) {
    switch (status) {
      case "In Progress":
        return "in-progress";
      case "Completed":
        return "completed";
      case "Merged":
        return "merged";
      default:
        return "td";
    }
  }

  return (
    <>
      {!isExternalMember && <Navbar />}
      <div className="grid-container-members">
        <div className="header">
          <div className="header-externalform-title">
            {/* Show the name if the external client if in the HecoAnalyst session */}
            {companyName} Data Request {!isExternalMember && `(${memberName})`}
          </div>
          <div className="header-externalform-snapshotName">{snapshotName}</div>
          <div className="header-datarequests-buttons">
            {/* Staus and DateTime */}
            <div className={getStatusClassName(status)}>
              {showStatus} {dateTime}
            </div>
            {/* Tooltips for DataRequests */}
            <GeneralTooltipsModal />
            {/* Button to submit the data by the external client */}
            <SubmitForm
              isExternalMember={isExternalMember}
              showCheckboxes={showCheckboxes}
              setShowCheckboxes={setShowCheckboxes}
              checkboxState={checkboxState}
            />
          </div>
        </div>
      </div>
    </>
  );
}
